export default {
  default: {
    title: 'Add a field to get started',
    paragraph:
    'You can add fields to this form template and use the form in digital pages to receive information from clients easily.',
  },
}
